module.exports = __webpack_public_path__ + "static/media/chalkboard-art.b39316c4.mov";